module.exports = __webpack_public_path__ + "static/media/styled-components.8c7af6c0.png";